import {
    LIST_PAYMENT_LOTS,
    LIST_PAYMENT_LOTS_SUCCESS,
    LIST_PAYMENT_LOTS_ERROR,
    BRANCH_PAYMENT_LOT,
    BRANCH_PAYMENT_LOT_SUCCESS,
    BRANCH_PAYMENT_LOT_ERROR
} from '../types';


import es from '../lang/es';
import api from '../helpers/api';
import apiMethods from '../constants/apiMethods';
import alertMessages from '../helpers/alertMessages';

//LIST PAYMENT LOTS
export function listPaymentLotsAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listPaymentLots() );
        //Ejecuto la consulta
        try{
            //Hago la consulta
            const response = await api.get(apiMethods.CHECKOUT);
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            dispatch( listPaymentLotsSuccess(res.data) );
        }catch(error){
            const response = error.response;
            //Inicializo
            let data = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listPaymentLotsError(data) );
        }
    }
}

const listPaymentLots = () => ({
    type: LIST_PAYMENT_LOTS,
    payload: true
});

const listPaymentLotsSuccess = paymentLots => ({
    type: LIST_PAYMENT_LOTS_SUCCESS,
    payload: paymentLots
});

const listPaymentLotsError = error => ({
    type: LIST_PAYMENT_LOTS_ERROR,
    payload: error
});

//BRANCH PAYMENT LOT
export function branchPaymentLotAction(paymentLot) {
    return async (dispatch) => {
        //Inicializo
        dispatch( branchPaymentLot() );
        //Ejecuto la consulta
        try{
            //Cargo la espera
            alertMessages.waiting(es.LOADINGS.PROCESSING);
            //Hago la consulta
            const response = await api.post(apiMethods.CHECKOUT_BRANCH(paymentLot.id));
            //Obtengo los datos
            const res = response.data;
            //Me fijo si viene la ruta
            if(res.data.voucher){
                //Descargo el comprobante
                window.open(res.data.voucher);
            }
            //Oculto la espera
            alertMessages.close();
            //Llamo al dispatch
            dispatch( branchPaymentLotSuccess(res.data) );
        }catch(error){
            console.log(error)
            const response = error.response;
            //Inicializo
            let data = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            alertMessages.close();
            //Llamo al dispatch
            dispatch( branchPaymentLotError(data) );
        }
    }
}

const branchPaymentLot = () => ({
    type: BRANCH_PAYMENT_LOT,
    payload: true
});

const branchPaymentLotSuccess = paymentLot => ({
    type: BRANCH_PAYMENT_LOT_SUCCESS,
    payload: paymentLot
});

const branchPaymentLotError = error => ({
    type: BRANCH_PAYMENT_LOT_ERROR,
    payload: error
});